import React, { useEffect, useState } from 'react';

import StripeScriptLoader from "../../common/components/StripeScriptLoader";
import {getStripePublishableKey} from "../../common/utils/config";
import MainForm from "./components/MainForm";

import {
  Elements,
  StripeProvider
} from "react-stripe-elements";

export default function App(props) {
  return (
    <StripeScriptLoader
      className="pro-landing-message"
      uniqueId='stripe-js'
      script='https://js.stripe.com/v3/'
      loader="Connecting to Stripe..."
    >
      <StripeProvider apiKey={getStripePublishableKey()}>
        <Elements>
          <MainForm {...props} />
        </Elements>
      </StripeProvider>
    </StripeScriptLoader>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/subscription_plan/index.js